import React from 'react';
import PropTypes from 'prop-types';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { FormGroup, Label, FormFeedback } from 'reactstrap';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

const PhoneInputField = ({
  label,
  name,
  value,
  setFieldValue,
  error,
  touched,
  country = 'ca',
  required = false,
}) => {
  const handlePhoneChange = (val) => {
    const phoneNumber = parsePhoneNumberFromString('+' + val);
    let formatted = val;
    if (phoneNumber) {
      formatted = phoneNumber.formatInternational().replace(
        /(\+\d+)\s(\d{3})\s(\d{3})\s(\d{4})/,
        '$1 ($2) $3-$4'
      );
    }
    setFieldValue(name, formatted);
  };

  return (
    <FormGroup className="mb-3">
      {label && <Label htmlFor={name}>{label} {required && '*'}</Label>}
      <PhoneInput
        country={country}
        value={value}
        enableSearch={true}
        onChange={handlePhoneChange}
        inputProps={{
          name,
          required,
        }}
        inputStyle={{
          width: '100%',
          borderColor: touched && error ? '#f46a6a' : undefined,
        }}
      />
      {touched && error && (
        <FormFeedback style={{ display: 'block' }}>{error}</FormFeedback>
      )}
    </FormGroup>
  );
};

PhoneInputField.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  setFieldValue: PropTypes.func.isRequired,
  error: PropTypes.string,
  touched: PropTypes.bool,
  country: PropTypes.string,
  required: PropTypes.bool,
};

export default PhoneInputField;
